// Central place for the API base URL and an authenticated fetch helper.
//
// Previously every page hardcoded its own "http://127.0.0.1:8000/api" or
// "https://juniorpersist.com/backend/public/api" string, and admin calls
// (list users, add/delete products, etc.) were sent with no auth at all
// because the backend didn't require any. The backend now requires a
// Sanctum bearer token on admin routes (see routes/api.php), so this
// helper attaches it automatically and centralizes the base URL.

export const API_URL =
  // process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';
  process.env.REACT_APP_API_URL || 'https://juniorpersist.com/backend/public/api';

export function getAuthToken() {
  return localStorage.getItem('auth-token');
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user-info') || 'null');
  } catch {
    return null;
  }
}

export function isAdmin() {
  const user = getStoredUser();
  return !!user && user.level === 'Admin';
}

export function clearAuth() {
  localStorage.removeItem('auth-token');
  localStorage.removeItem('user-info');
}

/**
 * fetch() wrapper that adds the Authorization header when we have a token
 * and prefixes relative paths with the API base URL.
 *
 * Usage: apiFetch('listProduct') or apiFetch('deleteProduct/5', { method: 'DELETE' })
 */
export async function apiFetch(path, options = {}) {
  const token = getAuthToken();
  const headers = {
    Accept: 'application/json',
    ...(options.headers || {}),
  };

  // Don't force Content-Type when sending FormData - the browser needs to
  // set its own multipart boundary.
  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const url = path.startsWith('http') ? path : `${API_URL}/${path.replace(/^\//, '')}`;

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401 || response.status === 403) {
    // Token missing/expired/not authorized - bounce back to login rather
    // than silently failing.
    clearAuth();
  }

  return response;
}
